// extracted by mini-css-extract-plugin
export default {"root":"ProfilePage_root__uK8Y4","wrapper":"ProfilePage_wrapper__ZtChB"};